import type { LinkedAccount, LinkedAccountPlatform } from "@store/linkedAccountSlice";
import { LinkedAccountsGrid } from "./LinkedAccountsGrid";
import { PlatformSectionHeader } from "./PlatformSectionHeader";

interface PlatformLinkedAccountsSectionProps {
  platform: LinkedAccountPlatform;
  accounts: LinkedAccount[];
}

export const PlatformLinkedAccountsSection = ({ platform, accounts }: PlatformLinkedAccountsSectionProps) => {
  return (
    <div className="flex w-full flex-col gap-[16px]">
      <PlatformSectionHeader platform={platform} />
      <LinkedAccountsGrid accounts={accounts} platform={platform} />
    </div>
  );
};
